import { z } from 'zod'

export const MEMBER = 'member'
export const OWNER = 'owner'
export const CLIENT = 'client'

export const companyRole = z.enum([MEMBER, OWNER, CLIENT])

export const companyRoles = Object.values(companyRole.enum)

export const colleagueRoles = [OWNER, MEMBER] as const

export type CompanyRole = z.infer<typeof companyRole>
